import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Thumbnail from "src/components/thumbnail";

import { getFullName } from "src/utils/utils";

import cx from "classnames";
import _ from "lodash";
import styles from "./leaderboard.module.scss";
import Text from "src/components/text";

const defaultAssetImage = "/images/defaultIcons/default_asset.jpg";

const LeaderboardReport: React.FC = () => {
  const { loading, userRank, leaderboards } = useSelector((state: any) => {
    const leaderboardState = _.get(
      state.coaching,
      "reports.learnings.leaderboard",
    );
    const loading = _.get(leaderboardState, "loading");
    const userRank = _.get(leaderboardState, "userRank");
    const leaderboards = _.get(leaderboardState, "leaders") || [];

    return {
      loading: loading,
      userRank: userRank,
      leaderboards: leaderboards,
    };
  }, _.isEqual);

  if(_.size(leaderboards) == 0 && !loading) {
    return <></>
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h3>top learners from your team</h3>
      </div>

      {loading && (
        <div className={cx(styles.grid, styles.block)}>
          {_.times(7, (index) => (
            <PlaceholderLeaderboardCard key={index} />
          ))}
        </div>
      )}

      {!loading && (
        <div className={styles.grid}>
          {userRank &&
            <div className={styles.wrapper}>
              <LeaderboardCard item={userRank} rank={userRank.rank} />
              <div className={styles.line}></div>
            </div>
          }

          {leaderboards.map((item, index) => (
            <div key={index} className={styles.wrapper}>
              <LeaderboardCard item={item} rank={item.rank} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

interface LeaderboardCardProps {
  item: any;
  rank: number;
}

const LeaderboardCard: React.FC<LeaderboardCardProps> = ({ item, rank }) => {
  return (
    <div key={item?.id} className={styles.card}>
      <div className={styles.avatar}>
        <div className={styles.number}>{rank}</div>
        <Thumbnail media={item?.user?.icon} defaultImage={defaultAssetImage} />
      </div>
      <div className={styles.content}>
        <Text className={styles.name} text={getFullName(item.user) || ""} lines={1} />
        <span className={styles.learnings}>
          {item?.completed} learnings completed
        </span>
      </div>
    </div>
  );
};

export default LeaderboardReport;

const PlaceholderLeaderboardCard: React.FC<object> = () => {
  return (
    <div className={cx(styles.card, styles.placeholder)}>
      <div className={cx(styles.avatar, styles.block)}></div>
      <div className={styles.content}>
        <div className={cx(styles.name, styles.block)}></div>
        <div className={cx(styles.learnings, styles.block)}></div>
      </div>
    </div>
  );
};
